<template>
  <div class="m-10">
    <button v-if="!externalNavigation"
        @click="showHowTo = true"
        class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-150 border border-indigo-500 hover:border-indigo-400"
      >
        How-To Configs
      </button>

    <HowToGuide
      v-if="isGuideVisible"
      :pages="configsGuidePages"
      :initial-page="0"
      @close="handleClose"
      @complete="handleGuideComplete"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import HowToGuide from "@/components/HowToGuide.vue";

import accountImage from "@/assets/howto/account/account.png";
import accountInformationImage from "@/assets/howto/account/account-information.png";
import accountStatusImage from "@/assets/howto/account/account-status.png";
import accountPermissions from "@/assets/howto/account/account-permissions.png";
import accountActions from "@/assets/howto/account/account-actions.png";
import accountPassword from "@/assets/howto/account/account-change-password.png";
import accountDelete from "@/assets/howto/account/account-delete.png";

import configImage from "@/assets/howto/workspace-config/config.png";
import configAddButtonImage from "@/assets/howto/workspace-config/config-add-button.png";
import configGlobalImage from "@/assets/howto/workspace-config/config-global.png";
import configHardwareMonitoringImage from "@/assets/howto/workspace-config/config-hardware-monitoring.png";
import configInterfaceMonitoringImage from "@/assets/howto/workspace-config/config-interface-monitoring.png";
import configSyntheticTransactionImage from "@/assets/howto/workspace-config/config-synthetic-transaction.png";
import configSynthTransactionImage from "@/assets/howto/workspace-config/config-synth-transaction.png";
import configCreateImage from "@/assets/howto/workspace-config/config-create-button.png";


export default {
  name: "ParentComponent",
  components: {
    HowToGuide,
  },
  
  props: {
    showHowToPage: {
      type: Boolean,
    },
    externalNavigation: {
      type: Boolean,
    }
  },

  emits: ["showHowToClose"],
  setup(props, { emit }) {
    const showHowTo = ref(false);

    const isGuideVisible = computed(() => {
      return props.externalNavigation ? props.showHowToPage : showHowTo.value;
    }); 

    const configsGuidePages = ref([
      {
          heading: "Navigate to Configs",
          upperText: [
              "From the main navigation menu, click on \"Workspace\".",
              "Select \"Configs\" from the submenu.",
              "You'll see the Configs Overview page showing all existing Configs."
          ],
          image: configImage,
          imageAlt: "Configs navigation screenshot",
          lowerText: []
      },
      {
          heading: "Initiate Config Creation",
          upperText: [
              "Click the \"Add Configs\" button.",
              "This will open the \"Add Configs\" form.",
          ],
          image: configAddButtonImage,
          imageAlt: "Config creation form",
          lowerText: []
      },
      {
          heading: "Initiate Config Creation",
          upperText: [
              "Click the \"Select a Config Type\" dropdown.",
              "Choose the config type from the list. This will produce additional configs."
          ],
          image: configAddButtonImage,
          imageAlt: "Config creation form",
          lowerText: [
              "When you select the Workspace Config in the config type dropdown the Interface Monitoring form appears.",
              "When you select the Launcher Config Level in the config type drop down the Launcher Config form appears.",
              "When you select the Collector Config in the config type drop down the Interface Monitoring and Hardware Monitoring forms appear."
          ]
      },
      {
          heading: "Select Organisation and Agents",
          upperText: [
              
          ],
          image: configGlobalImage,
          imageAlt: "Organisation and agent selection",
          lowerText: [
            "Click the \"Select an organisation\" button. Choose the organisation from the list.",
            "Click the \"Select an Agent Group\" button. Choose an agent group from the list (Optional).",
            "Click the \"Select an Agent\" button. Choose the agent from the list (Optional).",
          ]
      },
      {
        heading: "Interface Monitoring",
        upperText: [
            "Toggle on the configs you require (Interface Monitoring, Hardware Monitoring).",
            "Gateway ping - Checks if the network's gateway is reachable.",
            "Wi-Fi - Monitors the Wi-Fi connection status"
        ],
        image: configInterfaceMonitoringImage,
        imageAlt: "Interface monitoring configuration",
        lowerText: []
    },
    {
        heading: "Hardware Monitoring",
        upperText: [
          "Toggle on the configs you require (Interface Monitoring, Hardware Monitoring)."
        ],
        image: configHardwareMonitoringImage,
        imageAlt: "Hardware monitoring options",
        lowerText: []
    },
    {
        heading: "Hardware Monitoring",
        upperText: [],
        image: null,
        imageAlt: "Hardware monitoring options",
        lowerText: [
            "Process - Tracks CPU, memory, and process usage.",
            "Logical Disk - Monitors disk space, usage, and performance.",
            "Network Interface - Measures network traffic and errors on adapters.",
            "Memory - Reports on memory usage and faults.",
            "Processor - Tracks CPU performance across all cores.",
            "Physical Disk - Monitors read/write activity and disk performance.",
            "System - Provides overall system statistics such as uptime and queue length.",
            "Paging File - Monitors swap (paging file) usage."
        ]
    },
    {
        heading: "Synthetic Transactions",
        upperText: [
            "Click the \"Add New Synthetic Transaction\" button."
        ],
        image: configSyntheticTransactionImage,
        imageAlt: "Synthetic transactions configuration",
        lowerText: []
    },
    {
        heading: "Synthetic Transactions",
        upperText: [
            "Synthetic Transactions Overview Form"
        ],
        image: configSynthTransactionImage,
        imageAlt: "Synthetic transactions configuration",
        lowerText: []
    },
    {
        heading: "Synthetic Transactions",
        upperText: [],
        image: null,
        imageAlt: "Synthetic transactions configuration",
        lowerText: [
          "Input the “Name” of the synthetic transaction.",
          "Click on the “Protocol” drop-down and select the protocol eg. “tcp”",
          "Input the “Address” that the synthetic transaction will be using. eg. “8.8.8.8“.",
          "Input the tags for better understanding/specification.",
          "Click the “Save” button (blue button, bottom left).",
          "Click the “Create Config” button.",
          "This will complete the creation of the Agent Group.",

        ]
    },
    {
        heading: "Configure Tags and Complete",
        upperText: [
            "Input the tags for better understanding/specification.",
            "Click the \"save\" button (blue button, bottom left)."
        ],
        image: configCreateImage,
        imageAlt: "Tags configuration and completion",
        lowerText: [
            "Click the \"Create Config\" button."
        ]
    }
  ]);

    const handleGuideComplete = () => {
      showHowTo.value = false;
      emit("showHowToClose", false);
    };

    const handlePageChange = (pageIndex) => {
      console.log(`User navigated to page ${pageIndex + 1}`);
    };

    const handleClose = () => {
      if (props.externalNavigation){
        emit("showHowToClose", false);
      } else {
        showHowTo.value = false;
      }
    };

    return {
      showHowTo,
      configsGuidePages,
      handleGuideComplete,
      handlePageChange,
      handleClose,
      isGuideVisible
    };
  }
};
</script>